import Context from "shared/util/Context";
import OkC from "shared/util/OkcApi";
import _str from "shared/util/_str";
import isApp from "shared/util/isApp";
import UrlHelpers from "shared/util/UrlHelpers";

import { areAllAccepted, formatApiQuestion } from "apps/questions/util/helpers";
import { IMPORTANCES } from "apps/questions/util/constants";

const getSource = () => {
	const pathname = window && window.location ? window.location.pathname : "";

	if (isApp()) {
		if (UrlHelpers.getParam("targetid") || UrlHelpers.getParam("tuid")) {
			return "profile";
		} else {
			return "own_profile";
		}
	} else if (pathname.indexOf("home") >= 0) {
		return "desktop_binary_home";
	} else if (pathname.indexOf(Context.get("username")) >= 0) {
		return "own_profile";
	} else {
		return "profile";
	}
};

export function answerQuestion({
	id, answers, importance, isPrivate, explanation,
}, targetUserid) {
	const answer = answers.reduce((ans, { isSelected }, i) => (
		isSelected ? i + 1 : ans
	), null);

	const matchAnswers = answers.reduce((ans, { isAccepted }, i) => (
		isAccepted ? ans.concat(i + 1) : ans
	), []);

	let importanceToSend = IMPORTANCES.SOMEWHAT;

	if (areAllAccepted(answers)) {
		importanceToSend = IMPORTANCES.IRRELEVANT;
	} else {
		importanceToSend = importance;
	}

	return OkC.post(`/questions/${id}`, {
		data: {
			qid: id,
			answer,
			match_answers: matchAnswers,
			importance: importanceToSend,
			public: !isPrivate,
			note: explanation,
			source: getSource(),

			// a flag to get your answer info back in a front-end-ready format
			get_formatted_response: true,
			target_userid: targetUserid,
		},
	});
}

export function skipQuestion(question) {
	const id = question.id ? question.id : question.qid;

	return OkC.post(`/questions/${id}`, {
		data: {
			skip: true,
			source: getSource(),
		},
	});
}

export function answerBinaryQuestion({ id, answer }) {
	if (
		!id ||
		(answer !== "1" && answer !== "2")
	) {
		return Promise.reject({
			error: {
				message: _str("There was a problem saving your answer!"),
			},
		});
	}

	return OkC.post(`/questions/${id}`, {
		data: {
			answer: answer,
			match_answers: [answer],
			source: "desktop_binary_home",
		},
	});
}

export function fetchQuestion(qid) {
	return OkC.get(`/profile/me/questions/${qid}`)
		.then((res) => formatApiQuestion(res));
}

export function fetchNextQuestion() {
	return OkC.get("/questions/next", {
		// ie11 was caching the result of this query between requests since there
		// are no query params that change. passing `cache: false` tells jquery to
		// not use the browser cache for this ajax request.
		cache: false,
		data: {
			questions2017Format: true,
		},
	});
}



// WEBPACK FOOTER //
// ./src/apps/questions/util/web.js